import { spawn, call, takeLatest, put, all } from 'redux-saga/effects';

// Actions
import { validarDesafioCPAction } from '../../../../application/actions/validarDesafioCP';

// import { logReqError } from '../../../ui/utils/functions';

import api from '../../../api';

const apiValidarDesafioCP = api(process.env.REACT_APP_URL);

export function* fetchValidarCP(parametros) {
  try {
    const { codigo, trackid, autorizacion } = parametros.payload;

    const body = {
      codigo
    }
    
    const { data } = yield call(apiValidarDesafioCP.post,'/desafio/softtoken/validar', body , { 
        'Track-Id': trackid,
        'Authorization': autorizacion
     });

    if (data) {
      yield put(validarDesafioCPAction.fetchValidarDesafioCPSuccess({ respuestaServicio: data }));

    } else {
      yield put(validarDesafioCPAction.fetchValidarDesafioCPError({ respuestaServicio: "" }));

    }

  } catch {
      //Errores
    yield all([
      put(validarDesafioCPAction.fetchValidarDesafioCPError())
    ]);
  }
}

export function* watchFetchValidarCP() {
  yield takeLatest(validarDesafioCPAction.fetchValidarDesafioCP.type, fetchValidarCP);
}

export default function* rootSaga() {
  yield spawn(watchFetchValidarCP);
}
